/**
 * Instant Page Navigation v2
 * Aggressive prefetch + prerender for near-instant page transitions.
 */
(function(){'use strict';

// Bail on slow connections
if(navigator.connection){
  var c=navigator.connection;
  if(c.saveData||(c.effectiveType&&/2g/.test(c.effectiveType)))return;
}

var defined={};
var supportsSpeculation=HTMLScriptElement.supports&&HTMLScriptElement.supports('speculationrules');

function speculate(url,action){
  if(defined[url]>=2)return;
  defined[url]=2;
  if(!supportsSpeculation){
    // Fallback: prefetch
    var l=document.createElement('link');
    l.rel='prefetch';l.href=url;
    document.head.appendChild(l);
    return;
  }
  var s=document.createElement('script');
  s.type='speculationrules';
  var rule={};
  rule[action]=[{source:'list',urls:[url]}];
  s.textContent=JSON.stringify(rule);
  document.head.appendChild(s);
}

function prefetchOnly(url){
  if(defined[url])return;
  defined[url]=1;
  var l=document.createElement('link');
  l.rel='prefetch';l.href=url;l.as='document';
  document.head.appendChild(l);
}

function isLocal(a){
  if(!a||!a.href||a.origin!==location.origin)return false;
  if(a.pathname+a.search===location.pathname+location.search)return false;
  if(a.hash&&a.pathname===location.pathname)return false;
  if(a.hasAttribute('download')||a.target==='_blank')return false;
  // Skip non-page URLs
  var p=a.pathname;
  if(/\.(js|css|png|jpg|jpeg|gif|svg|ico|woff|woff2|mp4|webm|pdf|zip)$/i.test(p))return false;
  return true;
}

function getAnchor(el){
  while(el&&el.tagName!=='A')el=el.parentElement;
  return el;
}

// === HOVER: prerender after 50ms (desktop) ===
var hoverTimer;
document.addEventListener('mouseover',function(e){
  var a=getAnchor(e.target);
  if(!isLocal(a))return;
  clearTimeout(hoverTimer);
  hoverTimer=setTimeout(function(){
    speculate(a.href,'prerender');
  },50);
},{passive:true});

document.addEventListener('mouseout',function(){
  clearTimeout(hoverTimer);
},{passive:true});

// === MOUSEDOWN: prerender immediately (user is about to click) ===
document.addEventListener('mousedown',function(e){
  if(e.button!==0)return;
  var a=getAnchor(e.target);
  if(!isLocal(a))return;
  speculate(a.href,'prerender');
},{passive:true});

// === TOUCH: prerender on touchstart ===
document.addEventListener('touchstart',function(e){
  var a=getAnchor(e.target);
  if(!isLocal(a))return;
  speculate(a.href,'prerender');
},{passive:true});

// === VIEWPORT: prefetch visible data-instant links during idle ===
if('IntersectionObserver' in window){
  var queue=[];
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        obs.unobserve(entry.target);
        queue.push(entry.target.href);
      }
    });
    if(queue.length){
      var flush=function(){
        var batch=queue.splice(0,3);
        batch.forEach(prefetchOnly);
        if(queue.length){
          if('requestIdleCallback' in window) requestIdleCallback(flush,{timeout:2000});
          else setTimeout(flush,100);
        }
      };
      if('requestIdleCallback' in window) requestIdleCallback(flush,{timeout:1500});
      else setTimeout(flush,100);
    }
  },{rootMargin:'200px'});

  function observeLinks(){
    document.querySelectorAll('a[data-instant]').forEach(function(a){
      if(isLocal(a)&&!defined[a.href])obs.observe(a);
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observeLinks);
  else requestAnimationFrame(observeLinks);

  // Re-observe after AJAX
  var pending=false;
  new MutationObserver(function(){
    if(pending)return;pending=true;
    requestAnimationFrame(function(){observeLinks();pending=false;});
  }).observe(document.body,{childList:true,subtree:true});
}

// === GLOBAL SPECULATION RULES for common navigations ===
if(supportsSpeculation){
  // Moderate eagerness: prerender links user is likely to visit
  var globalRules=document.createElement('script');
  globalRules.type='speculationrules';
  globalRules.textContent=JSON.stringify({
    prefetch:[{
      source:'document',
      where:{selector_matches:'a[href][data-instant]'},
      eagerness:'moderate'
    }],
    prerender:[{
      source:'document',
      where:{selector_matches:'a[href][data-instant]'},
      eagerness:'moderate'
    }]
  });
  document.head.appendChild(globalRules);
}

})();
